export default "__VITE_ASSET__b378e3b5__"